module.exports = __webpack_public_path__ + "static/st2-6-7b773809cc10ed9e3af98dcfb79aa980.jpg";